{
    "percentagePaidByOwner": "Pourcentage pris en charge:",
    "percentagePaidByOwnerTitle": "Pourcentage pris en charge par l'organisateur. 100% correspond à prises en charge complète.",
    "percentagePaidByOwner100Title": "Entièrement prise en charge.",
    "adDocNormalPrice": "Prix: {inputPriceValue} {priceCurrency}",
    "adDocPremiumPrice": "Prix préférentiel: {inputPriceValue} {priceCurrency}",
    "adDocPriceZero": "Aucun frais",
    "percentagePaidByOwnerNTitle": "L'organisateur prend en charge {percentagePaidByOwner} % du prix."
  
}